import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { IJobDTO } from 'src/api/dtos';
import { IError } from 'src/api/types';

import { fetchJobs } from './jobs.actions';
import { IJobsState } from './jobs.types';

const initialState: IJobsState = {
  data: [],
  loading: false,
  error: null,
};

export const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    /* fetchJobs */
    build.addCase(fetchJobs.fulfilled.type, (state: Draft<IJobsState>, { payload }: PayloadAction<IJobDTO[]>) => {
      return {
        ...state,
        data: payload,
        loading: false,
      };
    });
    build.addCase(fetchJobs.pending.type, (state: Draft<IJobsState>) => {
      return {
        ...state,
        error: null,
        loading: true,
      };
    });
    build.addCase(fetchJobs.rejected.type, (state: Draft<IJobsState>, { payload }: PayloadAction<IError>) => {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    });
  },
});
